import { cardsData } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          深度报道
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">精选深度扒皮文章，每一篇都有料</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {cardsData.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-accent-300 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[4/3] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-sm font-semibold text-foreground-800 line-clamp-2 leading-snug group-hover:text-accent-700 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.excerpt}</p>
                <div className="flex items-center justify-between mt-auto pt-2">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="text-xs text-foreground-400">{item.reads} 阅读</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}